require('./general-report.component.scss');

class GeneralReportController {
  constructor(
    $scope,
    $http,
    PermissionService,
    FilterResource,
    ReportsSettingsModalService,
  ) {
    const getReportListErrorMsg = gettext('Ошибка при получении списка отчетов!');
    ReportsSettingsModalService.getReportList()
      .then(({
        data,
        status
      }) => {
        if (status != 200) {
          this.errorMessage.text = getReportListErrorMsg;
          this.errorMessage.error = true;
          return;
        }
        this.allReports = data.reports;
        this.setReports();
      }, err => {
        console.error(err);
        this.errorMessage.text = getReportListErrorMsg;
        this.errorMessage.error = true;
      });
  }

  getReport(id) {
    return this.allReports.find(r => r.id === id);
  }

  setReports() {
    if (this.reportsList)
      this.reportsList.split('\n').map(id => {
        const rep = this.getReport(id);
        if (rep) rep.selected = true;
      });
  }

  setReportsList() {
    this.reportsList = this.allReports.filter(r => r.selected).map(r => r.id).join('\n');
  }

  invert() {
    this.allReports.map(r => r.selected = !r.selected);
    this.setReportsList();
  }

  setSelect(select) {
    this.allReports.map(r => r.selected = select);
    this.setReportsList();
  }


}


export const GeneralReportComponent = {
  bindings: {
    reportsList: '=',
    errorMessage: '<'
  },
  template: require('./general-report.component.html'),
  controller: GeneralReportController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/general-report/general-report.component.js